const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogFaq(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogFaq`, params);
    },
    $obterRelatorioLogCSVFaq(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogFaqCsv`, params);
    },
    $obterRelatorioLogPDFFaq(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogFaqPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
